import { Card, Stack, Typography } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"
import { MarketNameIcon } from "@/components/atoms/MarketNameIcon"
import { type MarketName } from "@/constants/marketName"
import { NextIntlRichText } from "@/features/translations"

type MeterPoint = {
    id: string
    marketName: MarketName
    address: string
}

type MeterPointSummaryProps = {
    meterPoints: MeterPoint[]
}

export function MeterPointDualSummaryCard(props: MeterPointSummaryProps) {
    const t = useTranslations("MeterPointDualSummaryCard")

    const { meterPoints } = props

    if (meterPoints.length === 0) {
        return null
    }

    return (
        <Card
            theme="secondary900"
            fullWidth
            borderless
        >
            <NextIntlRichText>
                {(tags) => (
                    <Stack flexDirection="column">
                        <Stack>
                            <Typography>
                                {t.rich("address", {
                                    ...tags,
                                    address: meterPoints[0].address,
                                })}
                            </Typography>
                        </Stack>
                        {meterPoints.map((meterPoint) => (
                            <Stack key={meterPoint.id}>
                                <MarketNameIcon marketName={meterPoint.marketName} />
                                <Typography>
                                    {t.rich("meterPoint", {
                                        ...tags,
                                        marketName: meterPoint.marketName,
                                        meterPointId: meterPoint.id,
                                    })}
                                </Typography>
                            </Stack>
                        ))}
                    </Stack>
                )}
            </NextIntlRichText>
        </Card>
    )
}

MeterPointDualSummaryCard.messages = ["MeterPointDualSummaryCard"] as const
